import {
  AIRPORT_FILTER_CHANGED,
  ALLIANCE_FILTER_CHANGED,
  CARRIER_CONTROL_FILTER_CHANGED,
  CARRIERS_FILTER_CHANGED,
  DEPARTURE_TIMES_FILTER_CHANGED,
  DURATION_FILTER_CHANGED,
  FILTERS_RESET,
  LAYOVER_AIRPORT_FILTER_CHANGED,
  LAYOVER_AIRPORTS_CLEAR_ALL,
  LAYOVER_AIRPORTS_SELECT_ALL,
  LAYOVER_DURATION_FILTER_CHANGED,
  MIXED_AIRPORT_FILTER_CHANGED,
  STOPS_FILTER_CHANGED,
} from '../../../../../../actions/filters';
import { SORT_SELECTED } from '../../../../../../actions/sort';

import type { Action } from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type { FilterOrSortChangedCountState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/filterOrSortChangedCount';

export default function reducer(
  state: FilterOrSortChangedCountState = 0,
  action: Action,
): FilterOrSortChangedCountState {
  switch (action.type) {
    case SORT_SELECTED:
    case CARRIER_CONTROL_FILTER_CHANGED:
    case CARRIERS_FILTER_CHANGED:
    case STOPS_FILTER_CHANGED:
    case DEPARTURE_TIMES_FILTER_CHANGED:
    case ALLIANCE_FILTER_CHANGED:
    case AIRPORT_FILTER_CHANGED:
    case DURATION_FILTER_CHANGED:
    case MIXED_AIRPORT_FILTER_CHANGED:
    case LAYOVER_AIRPORT_FILTER_CHANGED:
    case LAYOVER_DURATION_FILTER_CHANGED:
    case LAYOVER_AIRPORTS_SELECT_ALL:
    case LAYOVER_AIRPORTS_CLEAR_ALL:
    case FILTERS_RESET:
      return state + 1;

    default:
      return state;
  }
}
export const get = (state: FilterOrSortChangedCountState): FilterOrSortChangedCountState => state;
